import script from "./PersonalAccountPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalAccountPage.vue?vue&type=script&setup=true&lang=ts"

import "./PersonalAccountPage.vue?vue&type=style&index=0&id=362600be&lang=scss&scoped=true"
import "./PersonalAccountPage.vue?vue&type=style&index=1&id=362600be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-362600be"]])

export default __exports__